export const TX_STATES = {
    IDLE: 'idle',
    ESTIMATING: 'estimating',
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    FAILED: 'failed'
};

export const createInitialTxStates = () => ({
    mint: TX_STATES.IDLE,
    claim: TX_STATES.IDLE
});

export const isTransactionInProgress = (txStates) => {
    return Object.values(txStates).some(state =>
        state === TX_STATES.ESTIMATING ||
        state === TX_STATES.PENDING
    );
};